import { apiGenerator } from '../../../framework/apis/apiGenerator';
import { env } from '../../../framework/utils/EnvUtils';
import { OutsourceMemberReportGetResult } from '../../models/gen/outsourceMemberReportGetResult';
import { OutsourceMemberReportWorkReportSaveParam } from '../../models/gen/outsourceMemberReportWorkReportSaveParam';
import {
  useGenericMutation,
  useGenericQuery,
} from '../../utils/ReactQueryUtils';
import { queryOptions } from './base';

export const OUTSOURCE_MEMBER_REPORT_CONTEXT_NAMES = {
  GET_OUTSOURCE_MEMBER_REPORT: 'getOutsourceMemberReport',
  POST_OUTSOURCE_MEMBER_REPORT_WORK_REPORT: 'saveOutsourceMemberWorkReport',
  POST_OUTSOURCE_MEMBER_REPORT_WORK_DOC_REPORT:
    'saveOutsourceMemberWorkDocReport',
} as const;

const apis = apiGenerator();

/**
 * GET `/outsource-member-report?authCode=`
 *
 * @param authCode
 * @returns
 */
export const useGetOutsourceMemberReport = (authCode: string | null) =>
  useGenericQuery(
    [
      OUTSOURCE_MEMBER_REPORT_CONTEXT_NAMES.GET_OUTSOURCE_MEMBER_REPORT,
      { authCode },
    ],
    async (_param) =>
      apis.get<void, OutsourceMemberReportGetResult>(
        `${env.BASE_API_ENDPOINT}/outsource-member-report?authCode=${authCode}`,
        {
          ...queryOptions,
          withoutAuthentication: true,
        }
      ),
    { enabled: false }
  );

/**
 * POST `/outsource-member-report/work-report`
 *
 * @returns
 */
export const usePostOutsourceMemberReportWorkReport = () =>
  useGenericMutation(async (param: OutsourceMemberReportWorkReportSaveParam) =>
    apis.post(`${env.BASE_API_ENDPOINT}/outsource-member-report/work-report`, {
      ...queryOptions,
      data: param,
      withoutAuthentication: true,
    })
  );

/**
 * POST `/outsource-member-report/work-doc-report`
 *
 * @returns
 */
export const usePostOutsourceMemberReportWorkDocReport = () =>
  useGenericMutation(async (param: FormData) =>
    apis.post(
      `${env.BASE_API_ENDPOINT}/outsource-member-report/work-doc-report`,
      {
        ...queryOptions,
        data: param,
        withoutAuthentication: true,
      }
    )
  );
